export type CameraHelpPlatform =
  | 'ios-safari'
  | 'ios-chrome'
  | 'android-chrome'
  | 'other';

export function detectCameraHelpPlatform(
  ua = typeof navigator === 'undefined' ? '' : navigator.userAgent
): CameraHelpPlatform {
  const ios = /iPhone|iPad|iPod/i.test(ua);
  const android = /Android/i.test(ua);
  if (ios && /CriOS/i.test(ua)) {
    return 'ios-chrome';
  }
  if (ios && /FxiOS|EdgiOS|OPiOS/i.test(ua)) {
    return 'other';
  }
  if (ios) {
    return 'ios-safari';
  }
  if (android) {
    return 'android-chrome';
  }
  return 'other';
}

export function cameraBlockedSteps(platform: CameraHelpPlatform): string {
  if (platform === 'ios-safari') {
    return 'Tap aA → Website Settings → Camera → Allow.';
  }
  if (platform === 'ios-chrome') {
    return 'Settings → Chrome → Camera on. Then reload.';
  }
  if (platform === 'android-chrome') {
    return 'Tap the lock by the URL → Permissions → Camera → Allow.';
  }
  return 'Allow camera for this site, then try again.';
}

export function isCameraDenied(err: unknown): boolean {
  if (!err || typeof err !== 'object') {
    return false;
  }
  const name = 'name' in err ? String((err as { name?: string }).name) : '';
  const message = err instanceof Error ? err.message : '';
  return (
    name === 'NotAllowedError' ||
    name === 'PermissionDeniedError' ||
    name === 'SecurityError' ||
    /permission denied|notallowed/i.test(message)
  );
}
